import { classNames } from '@library/utils';
import { useCallback } from 'react';

export interface MemberEntryCardProps {
  children?: React.ReactNode;
  className?: string;
  newWagerId: string;
  onShowModal: (newWagerId: string) => void;
}

export const MemberEntryCard = ({
  children = undefined,
  className = '',
  newWagerId,
  onShowModal
}: MemberEntryCardProps) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (['Enter', ' '].includes(e.key)) {
        onShowModal(newWagerId);
      }
    },
    [onShowModal, newWagerId]
  );

  const handleClick = () => {
    onShowModal(newWagerId);
  };

  return (
    <div
      className={classNames(
        'bg-soFresh-110 border-soFresh-140 font-heebo hover:bg-soFresh-120 flex w-[28rem] cursor-pointer flex-col rounded-lg border',
        className
      )}
      data-testid="member-entry-card"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  );
};
